import React, { useEffect, useState } from "react";
import { backend_url } from "../App";
import "./CSS/Analytics.css";

const Analytics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${backend_url}/api/analytics/dashboard`)
      .then((r) => r.json())
      .then((d) => { if (d.success) setData(d); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="an-page"><p className="an-loading">Loading analytics…</p></div>;
  if (!data) return <div className="an-page"><p className="an-loading">Failed to load analytics.</p></div>;

  const maxMonthRevenue = Math.max(1, ...data.revenueByMonth.map((m) => m.revenue));

  return (
    <div className="an-page">
      <div className="an-banner">
        <h2>📊 Analytics Dashboard</h2>
        <p>Computed live from real tailoring-order, fabric and print-design data.</p>
      </div>

      <div className="an-stats">
        <div className="an-stat-card"><div className="an-stat-value">₹{data.totals.totalRevenue.toLocaleString()}</div><div className="an-stat-label">Total Revenue</div></div>
        <div className="an-stat-card"><div className="an-stat-value">{data.totals.totalOrders}</div><div className="an-stat-label">Total Orders</div></div>
        <div className="an-stat-card"><div className="an-stat-value">{data.totals.totalCustomers}</div><div className="an-stat-label">Total Customers</div></div>
        <div className="an-stat-card"><div className="an-stat-value">{data.totals.repeatCustomerCount}</div><div className="an-stat-label">Repeat Customers</div></div>
        <div className="an-stat-card an-stat-profit"><div className="an-stat-value">₹{data.profitSummary.estimatedProfit.toLocaleString()}</div><div className="an-stat-label">Est. Profit</div></div>
      </div>

      <div className="an-grid">
        <div className="an-card">
          <h3>Revenue — Last 6 Months</h3>
          {data.revenueByMonth.every((m) => m.revenue === 0) ? (
            <p className="an-empty">No revenue recorded yet.</p>
          ) : (
            <div className="an-bars">
              {data.revenueByMonth.map((m) => (
                <div key={m.month} className="an-bar-col">
                  <div className="an-bar-track"><div className="an-bar-fill" style={{ height: `${(m.revenue / maxMonthRevenue) * 100}%` }} /></div>
                  <span className="an-bar-label">{m.month}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="an-card">
          <h3>Top Customers (Lifetime Value)</h3>
          {data.topCustomers.length === 0 ? <p className="an-empty">No orders yet.</p> : (
            <table className="an-table">
              <thead><tr><th>Customer</th><th>Orders</th><th>Revenue</th></tr></thead>
              <tbody>
                {data.topCustomers.map((c, i) => (
                  <tr key={i}><td>{c.name}</td><td>{c.orderCount}</td><td>₹{c.totalRevenue.toLocaleString()}</td></tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="an-card">
          <h3>Best Selling Fabrics — Fabric Profit Report</h3>
          {data.bestSellingFabrics.length === 0 ? <p className="an-empty">No fabric usage recorded yet.</p> : (
            <table className="an-table">
              <thead><tr><th>Fabric</th><th>Orders</th><th>Qty Used</th><th>Revenue</th><th>Fabric Cost</th><th>Profit</th></tr></thead>
              <tbody>
                {data.bestSellingFabrics.map((f, i) => (
                  <tr key={i}>
                    <td>{f.fabricType}</td>
                    <td>{f.orderCount}</td>
                    <td>{f.totalQuantityUsed}</td>
                    <td>₹{f.revenue.toLocaleString()}</td>
                    <td>₹{f.fabricCost.toLocaleString()}</td>
                    <td className="an-profit-cell">₹{(f.revenue - f.fabricCost).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="an-card">
          <h3>Best Selling Designs</h3>
          {data.bestSellingDesigns.length === 0 ? <p className="an-empty">No orders linked to a print design yet — set "Print Design Used" in an order's Order Info tab.</p> : (
            <table className="an-table">
              <thead><tr><th>Design</th><th>Orders</th><th>Revenue</th></tr></thead>
              <tbody>
                {data.bestSellingDesigns.map((d, i) => (
                  <tr key={i}><td>{d.floralCollection || d.printDesignId}</td><td>{d.orderCount}</td><td>₹{d.revenue.toLocaleString()}</td></tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="an-card">
          <h3>Orders by Occasion</h3>
          {data.ordersByOccasion.length === 0 ? <p className="an-empty">No orders yet.</p> : (
            <ul className="an-occasion-list">
              {data.ordersByOccasion.map((o, i) => (
                <li key={i}><span>{o.occasion}</span><strong>{o.count}</strong></li>
              ))}
            </ul>
          )}
        </div>

        <div className="an-card an-card-wide">
          <h3>Profit Report</h3>
          <div className="an-profit-row">
            <div><span>Total Revenue</span><strong>₹{data.profitSummary.totalRevenue.toLocaleString()}</strong></div>
            <div><span>Fabric Cost</span><strong>− ₹{data.profitSummary.totalFabricCost.toLocaleString()}</strong></div>
            <div><span>Labour Cost</span><strong>− ₹{data.profitSummary.totalLabourCost.toLocaleString()}</strong></div>
            <div className="an-profit-final"><span>Estimated Profit</span><strong>₹{data.profitSummary.estimatedProfit.toLocaleString()}</strong></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
